import React, { useContext } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { AuthContext } from './app/Context/auth.jsx';

/* Paginas */

import home from './app/pages/Principal/home/home.jsx';

/*------------- Gestão ------------------*/




/*Soluções*/

function App() {

  return <BrowserRouter>
    <Switch>
      <Route exact path='/' component={home} />
      <Route exact path='/*' component={home} />
    </Switch>
  </BrowserRouter>;
}

export default App;


